import { enUS } from "date-fns/locale/en-US";
import { es } from "date-fns/locale/es";
import { ptBR } from "date-fns/locale/pt-BR";
import type { Locale } from "date-fns";
import type { SiteLanguage } from "./language";

export function getDatePickerLocale(language: SiteLanguage): Locale {
  if (language === "en") return enUS;
  if (language === "es") return es;
  return ptBR;
}
